<template>
    <div>
        <ViewPaymentPurpose  v-if="!!item" @success="alertSuccess"></ViewPaymentPurpose>

        <PaymentPurposeTable
            title="Users"
            @addHealth="showPaymentPurposeModal"
            ref="table"
        ></PaymentPurposeTable>
        
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import PaymentPurposeTable from './PaymentPurposeTable'
import ViewPaymentPurpose from './ViewPaymentPurpose'
// import CreateVehicleForm from './CreateVehicleForm'

export default {
    name: 'payment-purpose',
    mixins: [popupMixins, permissionsMixins],
    components: {
        PaymentPurposeTable,
        ViewPaymentPurpose,
    },
    data: () => {
        return {
            item: null,
        }
    },

    methods: {
        alertSuccess(action) {
            console.log("asdasda",action)
            console.log(this.item)
            this.genericToast(
                this.componentName,
                action,
                'success',
                `${name} has been succcessfully ${action.toLowerCase()}`
            )
            //this.doToast('Success', `Item ${action}!`, 'success')
            this.item = null
            this.$refs.table.doSearch()
        },
        showPaymentPurposeModal() {
            this.$refs.createDocumentType.showModal()
        },
        // created() {
        //     this.doToast('Created!', 'Vehicle Created', 'success')
        //     this.$refs.table.doSearch()
        //     this.$refs.createVehicle.hideModal()
        // },
        handleError(error) {
            this.doToast(this.$translate('error'), error.message, 'danger')
        },
    },
}
</script>
<style></style>
